import React, { type ChangeEvent } from 'react';
import { useField } from 'react-final-form';

import { FormControlLabel, Switch } from '@mui/material';

type Props = {
  label: string;
  name: string;
};

export default function BooleanInput({ label, name }: Props) {
  const {
    input: { value, onChange },
  } = useField(name);

  return (
    <FormControlLabel
      label={label}
      control={
        <Switch
          name={name}
          checked={Boolean(value)}
          onChange={(ev: ChangeEvent<HTMLInputElement>, checked: boolean) => {
            onChange(checked);
          }}
        />
      }
    />
  );
}
